<template>
  <div>
    <span
      v-show="false && $route.name != 'IntroMarket'"
      class="i18n"
      @click="i18n($route.name)"
      >{{ $t("language") }}</span
    >

    <span v-show="$route.name != 'IntroMarket'" class="i18n">
      <button
        type="button"
        class="btn btn-default dropdown-toggle"
        data-toggle="dropdown"
      >
        LANG
        <span class="caret"></span>
        <span class="sr-only"></span>
      </button>
      <ul class="dropdown-menu" role="menu">
        <li><span style="padding: 0 5px" @click="i18n('zh')">中文</span></li>
        <li><span style="padding: 0 5px" @click="i18n('en')">ENGLISH</span></li>
        <li>
          <span style="padding: 0 5px" @click="i18n('vi')">VIETNAMESE</span>
        </li>
      </ul>
    </span>

    <span
      v-show="$route.name == 'IntroMarket'"
      class="i18n"
      @click="i18nNew($route.name)"
      >{{ $store.state.homeLang == "en" ? "中文" : "ENGLISH" }}</span
    >

    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: "LangBtn",
  data() {
    return {};
  },
  computed: {},
  mounted: function () {
    var that = this;

    console.log(this.$t('登录成功'));

    setTimeout(function () {
      that.enUrl = myutil.iframeBaseUrl + "/iframe/tradeIntro/intro.html";
      that.zhUrl = myutil.iframeBaseUrl + "/iframe/tradeIntro/introZH.html";
      that.$store.commit("set_homeIframeUrl", that.enUrl);

      that.enNewsUrl =
        myutil.iframeBaseUrl + "/iframe/tradingViewHtml/eventsEN.html";
      that.zhNewsUrl =
        myutil.iframeBaseUrl + "/iframe/tradingViewHtml/events.html";
      that.$store.commit("set_newsIframeUrl", that.enNewsUrl);
    }, 100);
  },
  methods: {
    i18nNew: function (name) {
      var that = this;
      if (this.$store.state.homeLang == "en") {
        this.$store.state.homeLang = "zh";
        that.zhUrl = myutil.iframeBaseUrl + "/iframe/tradeIntro/introZH.html";
        that.$store.commit("set_homeIframeUrl", that.zhUrl);
      } else {
        this.$store.state.homeLang = "en";
        that.enUrl = myutil.iframeBaseUrl + "/iframe/tradeIntro/intro.html";
        that.$store.commit("set_homeIframeUrl", that.enUrl);
      }
    },
    i18n: function (name) {
      var that = this;

      console.log(name);

      this.$i18n.locale = name;

      this.$store.commit("set_langOnPage", {
        IntroMarket: "en", // 首页
        other: name,
      });

      if (name == "zh") {
        (function ($) {
          $.fn.bootstrapTable.locales["zh-CN"] = {
            formatLoadingMessage: function formatLoadingMessage() {
              return "正在努力地加载数据中，请稍候……";
            },
            formatRecordsPerPage: function formatRecordsPerPage(pageNumber) {
              return (
                "\u6BCF\u9875\u663E\u793A " + pageNumber + " \u6761\u8BB0\u5F55"
              );
            },
            formatShowingRows: function formatShowingRows(
              pageFrom,
              pageTo,
              totalRows
            ) {
              return (
                "\u663E\u793A\u7B2C " +
                pageFrom +
                " \u5230\u7B2C " +
                pageTo +
                " \u6761\u8BB0\u5F55\uFF0C\u603B\u5171 " +
                totalRows +
                " \u6761\u8BB0\u5F55"
              );
            },
            formatSearch: function formatSearch() {
              return "搜索";
            },
            formatNoMatches: function formatNoMatches() {
              return "没有找到匹配的记录";
            },
            formatPaginationSwitch: function formatPaginationSwitch() {
              return "隐藏/显示分页";
            },
            formatRefresh: function formatRefresh() {
              return "刷新";
            },
            formatToggle: function formatToggle() {
              return "切换";
            },
            formatColumns: function formatColumns() {
              return "列";
            },
            formatExport: function formatExport() {
              return "导出数据";
            },
            formatClearFilters: function formatClearFilters() {
              return "清空过滤";
            },
          };

          $.extend(
            $.fn.bootstrapTable.defaults,
            $.fn.bootstrapTable.locales["zh-CN"]
          );
        })(jQuery);
      }
      if (name == "en") {
        (function ($) {
          $.fn.bootstrapTable.locales["en-US"] = {
            formatLoadingMessage: function formatLoadingMessage() {
              return "Loading, please wait...";
            },
            formatRecordsPerPage: function formatRecordsPerPage(pageNumber) {
              return pageNumber + " rows per page";
            },
            formatShowingRows: function formatShowingRows(
              pageFrom,
              pageTo,
              totalRows
            ) {
              return (
                "Showing " +
                pageFrom +
                " to " +
                pageTo +
                " of " +
                totalRows +
                " rows"
              );
            },
            formatSearch: function formatSearch() {
              return "Search";
            },
            formatNoMatches: function formatNoMatches() {
              return "No matching records found";
            },
            formatPaginationSwitch: function formatPaginationSwitch() {
              return "Hide/Show pagination";
            },
            formatRefresh: function formatRefresh() {
              return "Refresh";
            },
            formatToggle: function formatToggle() {
              return "Toggle";
            },
            formatColumns: function formatColumns() {
              return "Columns";
            },
            formatAllRows: function formatAllRows() {
              return "All";
            },
            formatExport: function formatExport() {
              return "Export data";
            },
            formatClearFilters: function formatClearFilters() {
              return "Clear filters";
            },
          };

          $.extend(
            $.fn.bootstrapTable.defaults,
            $.fn.bootstrapTable.locales["en-US"]
          );
        })(jQuery);
      }
      if (name == "vi") {
        (function ($) {
          $.fn.bootstrapTable.locales["vi-VN"] = {
            formatLoadingMessage: function formatLoadingMessage() {
              return "Đang tải...";
            },
            formatRecordsPerPage: function formatRecordsPerPage(pageNumber) {
              return pageNumber + " b\u1EA3n ghi m\u1ED7i trang";
            },
            formatShowingRows: function formatShowingRows(
              pageFrom,
              pageTo,
              totalRows
            ) {
              return (
                "Hi\u1EC3n th\u1ECB t\u1EEB trang " +
                pageFrom +
                " \u0111\u1EBFn " +
                pageTo +
                " c\u1EE7a " +
                totalRows +
                " b\u1EA3ng ghi"
              );
            },
            formatSearch: function formatSearch() {
              return "Tìm kiếm";
            },
            formatNoMatches: function formatNoMatches() {
              return "Không có dữ liệu";
            },
          };

          $.extend(
            $.fn.bootstrapTable.defaults,
            $.fn.bootstrapTable.locales["vi-VN"]
          );
        })(jQuery);
      }

      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.i18n {
  position: absolute;
  top: 8px;
  color: black;
  right: 10px;
  cursor: pointer;
  z-index: 999;
}
</style>






// WEBPACK FOOTER //
// src/components/LangBtn.vue